import { render, staticRenderFns } from "./SettedAlerts.vue?vue&type=template&id=f9a58b9e&"
import script from "./SettedAlerts.vue?vue&type=script&lang=js&"
export * from "./SettedAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports